import { render, staticRenderFns } from "./dynamic-document-lock-event-configuration-template.vue?vue&type=template&id=33cdbfba&scoped=true&"
import script from "./dynamic-document-lock-event-configuration-template.vue?vue&type=script&lang=ts&"
export * from "./dynamic-document-lock-event-configuration-template.vue?vue&type=script&lang=ts&"
import style0 from "./dynamic-document-lock-event-configuration-template.vue?vue&type=style&index=0&id=33cdbfba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cdbfba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VSpacer,VToolbar,VToolbarTitle})
